import React, { useMemo, useState } from "react";
import { Card, CardBody } from "reactstrap";
import Divider from "@mui/material/Divider";
import CustomTable from "views/pages/manage/common/data-grid/FlexiTable";
import { useWizard } from "components/wizard/WizardContext";
import Footer from "../Footer";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { getColumnList } from "./tableColumnConfig";
import ListingTopFilter from "./listingTopFilter";
import {
  useSearchStudentsHandler,
  useValidateTransferDetails,
} from "../../customHooks";
import { useNavigateToGivenPath } from "views/pages/manage/edpOps/studentDetails/paymentSummary/service";

const SelectStudent = ({
  searchHandler = () => {},
  getColumnList,
  FilterForm
}) => {
  const { updateValues, values, dropdowns } = useWizard();
  const navigateToGivenPath = useNavigateToGivenPath();
  const {
    searchStudentsFilters,
    selectedStudent,
    searchStudentsListing,
    searchStudentsLoading,
  } = values;

  // const { searchHandler } = useSearchStudentsHandler();
  // const { validate } = useValidateTransferDetails();
  const { applicationId, psid } = searchStudentsFilters;
  const {
    list,
    currentPage = 0,
    totalRecords = 0,
    totalPage = 0,
  } = searchStudentsListing;

  const inputHandler = (filter) => {
    const appliedFilter = { ...searchStudentsFilters, ...filter };
    searchHandler(appliedFilter, 0, false, 50);
  };

  const selectedStudentApplicationId = selectedStudent?.applicationId || "";

  const onStudentSelection = (row) => {
    updateValues("selectedStudent", row);
  };


  const updatePagination = (page = 0 , pageSize = 50)=>{
    const appliedFilter = searchStudentsFilters;
    searchHandler(appliedFilter, page, false, pageSize);
  }


  const businessAreaMap = useMemo(() => {
    return Object.fromEntries(
      (dropdowns?.data?.businessAres || []).map((bu) => [
        bu.label,
        bu.businessAreaDesc,
      ])
    );
  }, [dropdowns?.data?.businessAres]);

  const columns = useMemo(
    () =>
      getColumnList(
        onStudentSelection,
        selectedStudentApplicationId,
        businessAreaMap,
        navigateToGivenPath
      ),
    [onStudentSelection, selectedStudentApplicationId, businessAreaMap]
  );

  return (
    <>
      <Card style={{ margin: "18px", minHeight:"55vh" }} className="w-100 mb-2">
        <CardBody>
          <div className="d-flex justify-content-between align-items-center">
            <div className="dark-text heading-3 label-color">
            {selectedStudent?.psid?"1 Student selected":"Select students"}
            </div>
            <ListingTopFilter
              inputHandler={inputHandler}
              applicationId={applicationId}
              psid={psid}
              FilterForm={FilterForm}
              searchHandler={searchHandler}
            />
          </div>
          <div className="mb-2">
            <Divider className="mb-2" />
          </div>
          <CustomTable
            removeWrapperContainer
            rows={list || []}
            columns={columns}
            rowId={(row) => JSON.stringify(row)}
            rowHeight={50}
            loading={searchStudentsLoading}
            page={currentPage}
            totalPage={totalPage}
            totalRows={totalRecords}
            selectedId={selectedStudentApplicationId}
            pinLastColumn
            onPageSizeChange={(pageSize)=>updatePagination(0,pageSize )}
            onPageChange={(pageNo, pageSize)=>updatePagination(pageNo, pageSize)}
          />
        </CardBody>
      </Card>
    </>
  );
};
export default SelectStudent;
